import { NICmsContentComponent } from '@icms/core/content';
import { ICmsComponentCwvConfig } from '../../../catalog/config/component.config';

export namespace NCmsComponentVideo {
    export const ID = 'video';

    export interface IData extends NICmsContentComponent.IData, ICmsComponentCwvConfig {
        ratio: string;
        video_id: string;
        video_provider: 'youtube' | 'vimeo';
        video_autoplay: boolean;
        video_background: boolean;
        video_hide: boolean;
        background_image?: string;
    }
}
